import * as Styles from './styles';
import { IconButton, IconClose } from 'cdk-radial';
import toTestId from '../../testUtils/toTestId';
import { useTheme } from '../../contexts/Theme';
import * as HStyles from '../History/styles';

interface Props {
  isActive: boolean;
  name: string;
  iconText: string;
  onOpenClick: () => void;
  onCloseClick: () => void;
  iconColor: string;
}

export default function OpenFramesCard({
  name,
  iconColor,
  iconText,
  isActive,
  onOpenClick,
  onCloseClick,
}: Props) {
  const { darkMode } = useTheme();
  const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onCloseClick();
  };

  return (
      <HStyles.HistoryItemContent
        data-testid={`history-item-${name}`}>
        <Styles.FrameCard
          className={isActive ? 'activeCard' : 'inactiveCard'}
          onClick={onOpenClick}
          onKeyDown={(e: any) => {
            e.stopPropagation();
            if (e.key === 'Enter') {
              onOpenClick()
            }
          }}
          data-testid={`openFrameCard-${toTestId(name)}`}
          tabIndex={0}>
        <Styles.FrameCardHeader>
          <Styles.ProductIcon iconColor={iconColor}>
            {iconText || ''}
          </Styles.ProductIcon>
          <Styles.FrameCardLabel>{name}</Styles.FrameCardLabel>
          <Styles.CloseButton>
              <IconButton
                onClick={handleCloseClick}
                onKeyDown={(e: any) => {
                  e.stopPropagation();
                  if (e.key === 'Enter') {
                    handleCloseClick(e)
                  }
                }}
              icon={<IconClose />}
              backgroundAppearance={darkMode ? 'dark' : 'light'}
              tabIndex={0}
            />
          </Styles.CloseButton>
        </Styles.FrameCardHeader>
      </Styles.FrameCard>
    </HStyles.HistoryItemContent>
  );
}
